export const COMMON = {
  en: {
    authTitle: 'Sign In or Register',
    authSidebar: `<p>
    Using your account you are able:<br /><br />
    1. See the history of visits and services.<br />
    2. Buy club cards and passes.<br />
    3. Receive news and special offers on time.
    </p>`,
    authAgreement: 'Public offer',
    next: 'Next',
    password: 'Password',
    signIn: 'Sign In',
    forgotPassword: 'Forgot Password?',
    supportContactText: 'If you have questions, please contact support:',
    phone: 'Phone',
    workTime: 'from',
    authEmailPrompt: 'First, enter your email and we will try to find you',
    book: 'Book',
    bookOnline: 'Book online',
    certificates: 'Certificates',
    certificatesCatalog: 'Gift certificates',
    myCertificates: 'My certificates',
    authorize: 'Authorize',
    myVisits: 'My Visits',
    myBookings: 'My Bookings',
    myBookingsOnline: 'My Bookings',
    mySubscription: 'My Subscription',
    tickets: 'Tickets',
    cards: 'Cards',
    subscriptionCards: 'Subscriptions',
    myCardSubscription: 'My subscription',
    subscriptions: 'Subscriptions',
    logOut: 'Log Out',
    account: 'Account',
    welcome: 'Welcome, {{name}}',
    sendPasswordResetInstructions: 'Send password reset instructions',
    didntReceivePasswordResetInstructions:
      "Didn't receive password reset instructions?",
    sendConfirmation: 'Send confirmation',
    signUp: 'Sign Up',
    emailNotFound: 'This email address was not found :(',
    tryAnotherEmail: 'Try another email address?',
    orFillRegistrationForm: 'Or fill out the registration form:',
    firstName: 'First Name',
    lastName: 'Last Name',
    middleName: 'Middle Name',
    birthday: 'Date of Birth',
    iReadAndAgree: 'I have read and agree to the terms of',
    agreement: 'agreement',
    register: 'Register',
    didntReceiveConfirmationInstructions:
      "Didn't receive confirmation instructions?",
    deposit: 'Deposit',
    lastVisit: 'Last Visit',
    trainingsLastMonth: 'Number of visits in the last month',
    trainingsLastSixMonths: 'Number of visits in the last 6 months',
    activeServices: 'Active Services',
    purchasedServices: 'My services',
    myCards: 'My cards',
    myCardsRemaining: 'Remaining uses',
    myCardsUnlimited: 'Unlimited',
    myCardsValidThrough: 'Valid through',
    myCertificatesTable: 'My certificates',
    certificateBalance: 'Balance',
    certificateExpiresAt: 'Valid through',
    discounts: 'Discounts',
    daysAgo: 'days ago',
    visitsRemaining: 'visits remaining',
    unsubscribe: 'Unsubscribe',
    youAreAboutToUnsubscribe: 'You are about to unsubscribe from',
    cancel: 'Cancel',
    supportService: 'Support Service:',
    workTimeLabel: 'Work Time:',
    legalAddress: 'Legal Address:',
    'Email address': 'Email address',
    'Redirect info':
      'If you are already registered, we will redirect you to enter your password',
    Continue: 'Continue',
    changePassword: 'Change Password',
    enterNewPassword: 'Enter your new password',
    passwordConfirmation: 'Password Confirmation',
    saving: 'Saving...',
    Buy: 'Buy',
    'Buy dialog title': 'Payment for service',
    // Rendered through <Trans> — the tags make the name and the amount stand out.
    'Buy dialog description':
      'You are about to buy "<strong>{{name}}</strong>" for <strong>{{price}} UAH</strong>',
    'Email is required': 'Email is required',
    'Enter a valid email': 'Enter a valid email',
    'Email will be sent to the specified email':
      'Email will be sent to the specified email',
    'Go back': 'Go back',
    'No description': 'No description available',
    'More info': 'More info',
    currency: 'UAH',
    '/month': '/month',
    footerTagline: 'Your climbing journey starts here',
    allRightsReserved: 'All rights reserved.',
    contactUs: 'Contact Us',
    systemOnline: 'System online',
    'No services available': 'No services available',
    'Try changing filters or check back later':
      'Try changing filters or check back later',
    // The shared Select / MultiSelect empty state. The admin bundle carries it,
    // the client one did not, so every client select rendered the raw key.
    'No options available': 'No options available',
  },
  uk: {
    authTitle: 'Вхід або реєстрація',
    authSidebar: `<p>
    Особистий кабінет  {{companyName}} дозволяє тобі самостійно:<br /><br />
    - записуватись на тренування та класи;<br />
    - переглядати історію відвідувань;<br />
    - купувати абончики та керувати підпискою;
    </p>`,
    authAgreement: 'Публічна оферта',
    next: 'Далі',
    password: 'Пароль',
    signIn: 'Увiйти',
    forgotPassword: 'Забули Пароль?',
    supportContactText: 'Виникли питання – звертайтеся до служби пiдтримки:',
    phone: 'Телефон',
    workTime: 'з',
    authEmailPrompt: 'Спочатку вкажи свій e-mail і ми спробуємо знайти тебе',
    book: 'Забронювати',
    bookOnline: 'Записатися онлайн',
    certificates: 'Сертифікати',
    certificatesCatalog: 'Подарункові сертифікати',
    myCertificates: 'Мої сертифікати',
    authorize: 'Авторизуватися',
    myVisits: 'Мій кабінет',
    myBookings: 'Мої бронювання',
    myBookingsOnline: 'Мої записи',
    mySubscription: 'Моя підписка',
    tickets: 'Квитки',
    cards: 'Картки',
    subscriptionCards: 'Підписки',
    myCardSubscription: 'Моя підписка',
    subscriptions: 'Підписки',
    logOut: 'Вийти',
    account: 'Акаунт',
    welcome: 'Вiтаю, {{name}}',
    sendPasswordResetInstructions: 'Відправити iнструкцiю для змiни пароля',
    didntReceivePasswordResetInstructions:
      'Не отримали інструкцій щодо змiни пароля?',
    sendConfirmation: 'Надiслати пiдтвердження',
    signUp: 'Реєстрація',
    emailNotFound: 'Такої адреси не знайдено :(',
    tryAnotherEmail: 'Спробуємо іншу адресу?',
    orFillRegistrationForm: 'Або заповніть форму рeєстрації:',
    firstName: "Ім'я",
    lastName: 'Прізвище',
    middleName: 'По батькові',
    birthday: 'Дата народження',
    iReadAndAgree: 'Я прочитав і згоден з умовами',
    agreement: 'угоди',
    register: 'Зареєструватися',
    didntReceiveConfirmationInstructions:
      'Не отримали інструкцій щодо пiдтвердження?',
    deposit: 'Депозит',
    lastVisit: 'Останній візит',
    trainingsLastMonth: 'Кількість візитів за останній місяць',
    trainingsLastSixMonths: 'Кількість візитів за останні 6 місяців',
    activeServices: 'Активні Сервiси',
    purchasedServices: 'Мої послуги',
    myCards: 'Мої картки',
    myCardsRemaining: 'Кількість залишка для використання',
    myCardsUnlimited: 'Безлімітна',
    myCardsValidThrough: 'Діє до',
    myCertificatesTable: 'Мої сертифікати',
    certificateBalance: 'Баланс',
    certificateExpiresAt: 'Діє до',
    discounts: 'Знижки',
    daysAgo: 'днів тому',
    visitsRemaining: 'залишилось візитів',
    unsubscribe: 'Відписатися',
    youAreAboutToUnsubscribe: 'Ви збираєтеся відписатися від',
    cancel: 'Скасувати',
    supportService: 'Служба пiдтримки:',
    workTimeLabel: 'Робочий час:',
    legalAddress: 'Юридична адреса:',
    'Email address': 'Email адреса',
    'Redirect info':
      'Якщо ти вже зареєстрований, ми перенаправимо тебе на введення пароля',
    Continue: 'Продовжити',
    changePassword: 'Змінити пароль',
    enterNewPassword: 'Введіть новий пароль',
    passwordConfirmation: 'Підтвердження пароля',
    saving: 'Збереження...',
    Buy: 'Придбати',
    'Buy dialog title': 'Оплата послуги',
    'Buy dialog description':
      'Ви збираєтеся купити "<strong>{{name}}</strong>" на суму <strong>{{price}} грн</strong>',
    'Email is required': "Email обов'язковий",
    'Enter a valid email': 'Введіть коректний email',
    'Email will be sent to the specified email':
      'Код для використання сертифіката буде надіслано на вказаний email',
    'Go back': 'Повернутись',
    'No description': 'Опис відсутній',
    'More info': 'Детальніше',
    currency: 'грн',
    '/month': '/місяць',
    footerTagline: 'Твоя скелелазна подорож починається тут',
    allRightsReserved: 'Усі права захищено.',
    contactUs: 'Контакти',
    systemOnline: 'Система працює',
    'No services available': 'Послуги відсутні',
    'Try changing filters or check back later':
      'Спробуйте змінити фільтри або перевірте пізніше',
    'No options available': 'Немає доступних варіантів',
  },
};
